import 'babel-polyfill';
import 'whatwg-fetch'; // fetch

// import modules/components
import './polyfills';
import './modules/ga-events';
import './modules/form';
import './modules/nav';
import './modules/tabs';
import './modules/accordian';
import './modules/placeholder-cycle';
import './modules/scrollbar-fix';
import './modules/scroll-carousel';
import './modules/elp-sticky';
import './modules/elp-tile-slider';
import './modules/elp-tag-filters';
import './modules/elp-podcast';
import './modules/elp-resource';
import './modules/elp-vimeo-playlist';
import './modules/carousel';
import './modules/lightbox';
import './modules/sticky-nav';
import './modules/share';
import './modules/video-vimeo';
import './modules/complete';
import './modules/sidebar';
import './modules/search-popout';
import './modules/nav-carousel';
import './modules/notifications';
import './modules/personalisation';
import './modules/vimeo-playlist';
import './modules/radio-deselect-event';
import './modules/InputMask';
import './modules/ShowIf';
import './modules/QuantityInputs';
import './modules/cc-breach-form';
import './modules/administered-to-patient-yesno';
import './modules/cc-accordion';
import './modules/PageTracker';
import './modules/quotebox';
import './modules/page-loading-state';

// import page specific scripts
import './pages/home-public';
import './pages/vaccine-disease-article';
import './pages/contact';
